import { VNode, VNodeData } from 'vue';
import { Component, Vue } from 'vue-property-decorator';
import { DynamicTemplateConfig } from '../../models';
import { Dictionary } from '../../utils';

export type MapVNodeData = (data: VNodeData) => VNodeData;

type KeyAndConfig = [string, DynamicTemplateConfig];

@Component
export class DynamicTemplateMixin extends Vue {
  private mapData: MapVNodeData;

  public renderComponents(componentsConfig: Dictionary<DynamicTemplateConfig>, mapData?: MapVNodeData): VNode[] {
    this.mapData = mapData;
    return this.createComponentsRecursively(componentsConfig) ?? [];
  }

  protected createComponentsRecursively(componentsConfig: Dictionary<DynamicTemplateConfig>): VNode[] | undefined {
    if (componentsConfig) {
      return Object.entries(componentsConfig)
        .filter(this.hasConfig)
        .sort(this.sortByOrder)
        .map(this.createComponent);
    }
  }

  protected hasConfig([, config]: KeyAndConfig): boolean {
    return !!config;
  }

  protected sortByOrder([, aConfig]: KeyAndConfig, [, bConfig]: KeyAndConfig): number {
    return (aConfig.order || 0) - (bConfig.order || 0);
  }

  protected createComponent([key, config]: KeyAndConfig): VNode {
    let data = { ...config.data };
    if (!data.key) {
      data.key = key;
    }
    if (this.mapData) {
      data = this.mapData(data);
    }
    const children = this.createComponentsRecursively(config.children);
    return this.$createElement(config.component, data, children);
  }
}
